
import React, {useEffect, useState} from 'react';
import {BrowserRouter as Router, Route, Switch} from 'react-router-dom';
import AOS from 'aos';
import {connect} from 'react-redux';
import 'toastr/build/toastr.min.css';
import {addLoftyUser, deleteLoftytoken} from './actions/auth.actions';
import { loftySendVisitProject } from './util/visitsprojects';

// pages
import main from './pages/main/main'
import nosotros from './pages/nosotros/nosotros'
import services from './pages/services/services'
import blog from './pages/blog/blog'
import articulo from './pages/articulo/articulo'
import contactus from './pages/contactus/contactus'
import soluciones from './pages/soluciones/soluciones'
import casosdeexito from './pages/casosdeexito/casosdeexito'
import caso from './pages/caso/caso'
import error4049ddqy from './pages/error4049ddqy/error4049ddqy'


// css
import './App.css';
import 'aos/dist/aos.css';

AOS.init();

function initSwiper() {
  // eslint-disable-next-line no-undef
  const swiper = new Swiper('.mySwiper', {
    spaceBetween: 30,
    centeredSlides: true,
    autoplay: false,
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
  });
  // console.log('swiper :>> ', swiper);
}

const App = ({loftytoken, addLoftyUserApp, deleteLoftytokenApp}) => {

  // agregando iniciación para el Swipper
  useEffect(() => {
    setTimeout(() => {
      initSwiper();
    }, 2000);
  }, []);

  useEffect(() => { loftySendVisitProject() }, []);

  

  return (
    <Router>
      <Switch>
			<Route exact path="/" component={main} />
			<Route exact path="/sobregrowth" component={nosotros} />
			<Route exact path="/services" component={services} />
			<Route exact path="/blog" component={blog} />
			<Route exact path="/articulo/:idblog" component={articulo} />
			<Route exact path="/contactanos" component={contactus} />
			<Route exact path="/soluciones" component={soluciones} />
			<Route exact path="/casosdeexito" component={casosdeexito} />
			<Route exact path="/caso/:idcaso" component={caso} />
			<Route exact path="*" component={error4049ddqy} />

      </Switch>
    </Router>
  );
}

const mapStateToProps = (state) => state.auth;

const mapDispatchToProps = (dispatch) => ({
  addLoftyUserApp: (user) => dispatch(addLoftyUser(user)),
  deleteLoftytokenApp: () => dispatch(deleteLoftytoken()),
});

export default connect(mapStateToProps, mapDispatchToProps)(App);

